import { memo, useMemo } from "react";

import { TableThWithSortIcon } from "@sso/components/TableThWithSortIcon";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { setAPIAccountSortColumn } from "@sso/store/slices/apiAccount";
import { APIAccountKeys, ExtendedAPIAccountList, TableColumn } from "@sso/types";
import { Table, TableWrapper, TD, TH } from "@sso/ui/Table";

import { APIAccountsTableActions } from "./APIAccountsTableActions";

interface APIAccountTableProps {
  apiAccountList: ExtendedAPIAccountList[];
  columns: TableColumn<APIAccountKeys>[];
}

export const APIAccountsTable = memo(({ apiAccountList, columns }: APIAccountTableProps) => {
  const dispatch = useAppDispatch();

  const data: ExtendedAPIAccountList[] = useMemo(
    () =>
      apiAccountList.map(item => ({
        ...item,
        [APIAccountKeys.SOFTWARES_NAME]: item.software?.name,
        [APIAccountKeys.LAST_USED]: item.lastUsed ? new Date(item.lastUsed).toLocaleDateString() : "-",
      })),
    [apiAccountList],
  );

  const handleSortAction = (column: string) => dispatch(setAPIAccountSortColumn(column));

  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            {columns.map(col => (
              <TH key={col.field} sortable={col.sortable} onClick={() => col.sortable && handleSortAction(col.field)}>
                {col.sortable ? <TableThWithSortIcon column={col.field} title={col.name} /> : col.name}
              </TH>
            ))}
            <TH textAlign="center">Actions</TH>
          </tr>
        </thead>
        <tbody>
          {data.map(apiAccount => (
            <tr key={apiAccount.apiAccountId} id={apiAccount.apiAccountId}>
              {columns.map(col => (
                <TD key={col.field} id={col.field}>
                  {apiAccount[col.field]}
                </TD>
              ))}
              <APIAccountsTableActions apiAccountId={apiAccount.apiAccountId} />
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrapper>
  );
});
